const audienceSection = $('#audience-section');

const addAudienceCardHoverAnimation = (audienceCards) => {
  const hoverEasing = CustomEase.create('hoverEasing', '0.6, 0.0, 0.2, 1.0');
  const cardImages = audienceCards.find('.audience-card-image');
  cardImages.eq(0).css({ right: '0', 'transform-origin': 'center right' });
  cardImages.eq(1).css({ left: '0', 'transform-origin': 'center left' });
  const cardWidth = pxToVw(audienceCards.eq(0).outerWidth());

  audienceCards.each(function (index) {
    $(this).on('mouseenter', () => {
      gsap.to(audienceCards.eq(index), {
        width: `${cardWidth * 1.1}vw`,
        duration: 0.5,
        ease: 'hoverEasing',
      });
      gsap.to(cardImages.eq(index), {
        scale: 1.28,
        //x: '8.005426vw',
        duration: 0.5,
        ease: 'hoverEasing',
      });

      gsap.to(audienceCards.eq((index + 1) % 2), {
        width: `${cardWidth * 0.9}vw`,
        duration: 0.5,
        ease: 'hoverEasing',
      });
    });
    $(this).on('mouseleave', () => {
      gsap.to(audienceCards.eq(index), {
        width: `${cardWidth}vw`,
        duration: 0.5,
        ease: 'hoverEasing',
      });
      gsap.to(cardImages.eq(index), {
        scale: 1,
        x: 0,
        duration: 0.5,
        ease: 'hoverEasing',
      });
      gsap.to(audienceCards.eq((index + 1) % 2), {
        width: `${cardWidth}vw`,
        duration: 0.5,
        ease: 'hoverEasing',
      });
      gsap.to(cardImages.eq((index + 1) % 2), {
        scale: 1,
        x: 0,
        duration: 0.5,
        ease: 'hoverEasing',
      });
    });

  });
};

const addAuedienceAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };
  const audienceCards = audienceSection.find('.audience-card');

  const audienceTL = gsap.timeline({
    paused: true,
  });

  audienceTL.add(
    animateSectionTopperIn({
      sectionParent: audienceSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );
  audienceTL.add(() => {
    addAudienceCardHoverAnimation(audienceCards);
  }, 1.3);

  audienceCards.each(function (index) {
    audienceTL.add(addElementInAnimation($(this), '36%', 1, 0).play(), 0.3 * index);
  });

  return audienceTL;
};

const audienceTrigger = () => {
  const audienceTL = addAuedienceAnimation();
  ScrollTrigger.create({
    trigger: audienceSection,
    start: 'top top+=110%',
    end: 'bottom bottom',
    once: true,
    onUpdate: (self) => {
      audienceTL.progress(self.progress);
    },
  });
}

/*
$(window).on('load', () => {
  audienceTrigger();
});
*/

addSectionObserver(audienceSection, audienceTrigger, false);
